<div class="header">
  <div class="calculate">
    <h3>
      {{ headerCalculatorRatingRow.title }}
    </h3>
    <div class="row">
      @for (column of headerCalculatorRatingRow.columns; track $index) {
        <div class="row-item">
          {{ column.title }}
        </div>
      }
    </div>
  </div>
  <div class="product">
    <h3>
      {{ headerProductRatingRow.title }}
    </h3>
    <div class="row">
      @for (column of headerProductRatingRow.columns; track $index) {
        <div class="row-item">
          {{ column.title }}
        </div>
      }
    </div>
  </div>
  <div
    class="weekly"
    appScrollSync
    [sourceName]=`rating-weekly-header`
    [syncGroup]="'rating-weekly'"
  >
    <h3>
      {{ headerWeekliesRatingRow.title }}
    </h3>
    <div class="row">
      @for (item of weeklyColumns; track $index) {
        <div class="header-row-item">
          <div class="header-row-item-week">Неделя {{ item + 1 }}</div>
          <div>{{ getDateRangeValue($index) }}</div>
        </div>
      }
    </div>
  </div>
</div>
